import kolosaLaboro from './kolosa_laboro';
import priTalismanoj from './pri_talismanoj';
import priStelsemantoj from './pri_stelsemantoj_en_la_ora_nordo';
import priOnkloVanja from './pri_onklo_vanja';
import provoDeMemrecenzo from './provo_de_memrecenzo';
import provoDeRecenzo from './provo_de_recenzo';
import kunvojaĝu from './kunvojaĝu';


const list = [
	priOnkloVanja,
	kolosaLaboro,
	priStelsemantoj,
	priTalismanoj,
	provoDeMemrecenzo,
	provoDeRecenzo,
	kunvojaĝu
];

export default list;